/**
 * Раздел «Скидки» = тонкая обёртка над PromoCodesList/Form в режиме auto-discounts.
 * Backend route — тот же /api/promo-codes, фильтруется через ?autoApply=true.
 * Создан как отдельный ресурс чтобы получить отдельный пункт меню и URL /discounts.
 */
import { PromoCodesList, PromoCodesForm } from '../promo-codes';

export function DiscountsList() {
  return <PromoCodesList mode="auto-discounts" />;
}

export function DiscountsForm() {
  return <PromoCodesForm mode="auto-discounts" />;
}
